import * as yup from 'yup';

export const publisherOptions = yup
  .object({
    publisherType: yup.bool().label('Publisher Type').notRequired(),
    status: yup
      .string()
      .oneOf(['Draft', 'Published'])
      .default('Draft')
      .label('Publishing Status')
      .notRequired(),
  })
  .notRequired();

export const commonFields = {
  description: yup.string().label('Description').notRequired(),
  publisherOptions,
};

export const commonSchema = yup.object(commonFields);
